import { getMarketCollectionPage } from '@/api/market';
import { EXPLORE_COLLECTION_QUERY, PAGE_SIZE } from '@/domain/market/feed-query';
import { createFeedSourceAdapter } from '@/domain/market/feed-source-adapter.js';
import {
  fetchPagesUntilUpdownNormalized,
  normalizeHomeFeedRows,
} from '@/domain/crypto/crypto-minute-feed-pagination.js';

export async function fetchExploreFeedPageResult(ctx) {
  const { append, pageNum, pageSize = PAGE_SIZE, state } = ctx;
  const startPageNum = append ? pageNum + 1 : 1;
  const baselineRows = append ? state?.rawRows ?? [] : [];

  return fetchPagesUntilUpdownNormalized({
    pageSize,
    startPageNum,
    append,
    baselineRows,
    normalizeRows: (rows) => normalizeHomeFeedRows(rows, 'all'),
    fetchRawPage: async (page) => {
      const data = await getMarketCollectionPage(EXPLORE_COLLECTION_QUERY, {
        pageNum: page,
        pageSize,
      });
      return { data, rows: Array.isArray(data?.rows) ? data.rows : [] };
    },
  });
}

export function createExploreFeedFetchOptions() {
  return createFeedSourceAdapter({
    logTag: 'exploreFeed',
    pageSize: PAGE_SIZE,
    buildQuery: () => EXPLORE_COLLECTION_QUERY,
    fetchPageResult: fetchExploreFeedPageResult,
  });
}
